export const notificationActionTypes = {
    SET_SEARCH_NOTIFICATION_DATA: 'SET_SEARCH_NOTIFICATION_DATA',
    SET_DOWNLOAD_NOTIFICATION_DATA: 'SET_DOWNLOAD_NOTIFICATION_DATA',
    SET_COMMENT_NOTIFICATION_DATA: 'SET_COMMENT_NOTIFICATION_DATA'
};
